import { EnumFeature, EnumScreenName } from '@calm/evexia-analytics';
import { routes } from '@rhg/utils/routes';

export const analyticsRouteMap: Record<string, [EnumScreenName, EnumFeature]> =
    {
        [routes.auth]: [EnumScreenName.Login, EnumFeature.LoginRegistration],
        [routes.expired]: [
            EnumScreenName.Expired,
            EnumFeature.LossOfSponsorship,
        ],
        [routes.saml]: [EnumScreenName.Saml, EnumFeature.LoginRegistration],
        [routes.sso]: [
            EnumScreenName.SsoInFocus,
            EnumFeature.LoginRegistration,
        ],
        [routes.reconsent]: [EnumScreenName.Consent, EnumFeature.Consent],
        [routes.ssoInfo]: [EnumScreenName.SsoIn, EnumFeature.LoginRegistration],
        [routes.completed]: [
            EnumScreenName.HomeLibraryViewAllCompleted,
            EnumFeature.Home,
        ],
        [routes.dashboard]: [EnumScreenName.Landing, EnumFeature.Home],
        [routes.library]: [EnumScreenName.HomeLibrary, EnumFeature.Home],
        [routes.login]: [
            EnumScreenName.LoginRegistration,
            EnumFeature.LoginRegistration,
        ],

        [routes.discover]: [EnumScreenName.Discover, EnumFeature.Discover],
        [routes.discoverPack('[packClass]')]: [
            EnumScreenName.DiscoverCategory,
            EnumFeature.Discover,
        ],
        [routes.discoverDailies('')]: [
            EnumScreenName.DailyDetail,
            EnumFeature.Discover,
        ],
        [routes.discoverDailies('[dailyId]')]: [
            EnumScreenName.DailyDetail,
            EnumFeature.Discover,
        ],
        [routes.discoverClinical]: [
            EnumScreenName.DiscoverClinical,
            EnumFeature.Discover,
        ],
        [routes.logout]: [
            EnumScreenName.LoggedOut,
            EnumFeature.LoginRegistration,
        ],
        [routes.health]: [EnumScreenName.Health, EnumFeature.Health],
        [routes.careplan]: [EnumScreenName.CarePlan, EnumFeature.CarePlan],
        [routes.carePlanAllRecommendations]: [
            EnumScreenName.CarePlanAllRecommendations,
            EnumFeature.CarePlan,
        ],
        [routes.profile]: [EnumScreenName.Profile, EnumFeature.Profile],
        [routes.recent]: [
            EnumScreenName.HomeLibraryViewAllRecentlyPlayed,
            EnumFeature.Home,
        ],
        [routes.settings]: [EnumScreenName.Settings, EnumFeature.Profile],
        [routes.notifications()]: [
            EnumScreenName.Notifications,
            EnumFeature.UkCanada,
        ],
        [routes.signup]: [EnumScreenName.Signup, EnumFeature.LoginRegistration],
        [routes.favorites]: [
            EnumScreenName.HomeLibraryViewAllFavorites,
            EnumFeature.Home,
        ],
        [routes.sponsor]: [EnumScreenName.Sponsor, EnumFeature.Profile],
        [routes.goals({ isFtue: false })]: [
            EnumScreenName.GoalSelection,
            EnumFeature.FtueSurvey,
        ],
        [routes.topics({ isFtue: false })]: [
            EnumScreenName.TopicSelection,
            EnumFeature.FtueSurvey,
        ],
        [routes.conditions({ isFtue: false })]: [
            EnumScreenName.Conditions,
            EnumFeature.Conditions,
        ],
        [routes.registration]: [
            EnumScreenName.Registration,
            EnumFeature.LoginRegistration,
        ],
        ['/program']: [
            EnumScreenName.ProgramDetail,
            EnumFeature.ClinicalProgram,
        ],
        [routes.notFound]: [EnumScreenName.NotFound, EnumFeature.Error],
        [routes.error({})]: [EnumScreenName.Error, EnumFeature.Error],
        // These are covered by analyticsRouteQueryMap these are fallbacks
        [routes.screening({ isFtue: false })]: [
            EnumScreenName.MentalHealthSurveyStart,
            EnumFeature.MentalHealthSurvey,
        ],
        [routes.results({ isFtue: false })]: [
            EnumScreenName.MentalHealthSurveyResults,
            EnumFeature.MentalHealthSurvey,
        ],
        [routes.standaloneScreening]: [
            EnumScreenName.StandaloneScreening,
            EnumFeature.StandaloneScreening,
        ],
        [routes.standaloneResults]: [
            EnumScreenName.StandaloneScreeningResults,
            EnumFeature.StandaloneScreening,
        ],
        [routes.nonUsResident]: [
            EnumScreenName.NonUsResidentBlocker,
            EnumFeature.StandaloneScreening,
        ],
        [routes.profileInvite({})]: [
            EnumScreenName.DependentInviteManage,
            EnumFeature.FriendsAndFamily,
        ],
    };
